import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { ThemeProvider } from '@mui/material/styles';
import Footer from '../../components/footer';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import AppBarWithMenu from '../../components/appbarwithmenu';
import appTheme from '../../components/apptheme';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import * as accountActions from '../../actions/accountActions';
import validateChangePasswordForm from './ValidateChangePasswordForm';
import { useSnackbar } from 'notistack';
import * as Constants from '../../config/constants';
import { InputAdornment, IconButton } from '@mui/material';
import { Visibility } from '@mui/icons-material';
import { VisibilityOff } from '@mui/icons-material';
import * as loginActions from '../../actions/loginActions';

export default function ChangePassword() {
  const st = useSelector((state) => state.rootReducer);
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [changePasswordSubmitted, setChangePasswordSubmitted] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const handleClickShowPassword1 = () => setShowPassword1(!showPassword1);
  const handleMouseDownPassword1 = () => setShowPassword1(!showPassword1);
  const [showPassword2, setShowPassword2] = useState(false);
  const handleClickShowPassword2 = () => setShowPassword2(!showPassword2);
  const handleMouseDownPassword2 = () => setShowPassword2(!showPassword2);
  const [showPassword3, setShowPassword3] = useState(false);
  const handleClickShowPassword3 = () => setShowPassword3(!showPassword3);
  const handleMouseDownPassword3 = () => setShowPassword3(!showPassword3);
  useEffect(() => {
    //banner success message
    if (changePasswordSubmitted && !st.isUpdateAccountPasswordLoading && st.updatepwderror === '') {
      enqueueSnackbar(Constants.UPDATE_PASSWORD_SUCCESS, {
        variant: 'success'
      });
      setChangePasswordSubmitted(false);
      navigate('/sop2web/profile');
    }
  }, [st.isUpdateAccountPasswordLoading, changePasswordSubmitted, st.updatepwderror]);

  const submitChangePassword = (values) => {
    dispatch(accountActions.requestUpdatePassword(values.password, values.newPassword));
    setChangePasswordSubmitted(true);
  };

  return (
    <ThemeProvider theme={appTheme}>
      <AppBarWithMenu />
      <Grid container component="main" sx={styles.containerStyle}>
        <Grid item xs={12} md={12} lg={12} sx={styles.contentStyle}>
          <Box sx={styles.formCardContainerStyle}>
            <Box
              component="img"
              alt="Heart Opinion"
              src={require('../../images/Person.png')}
              sx={{ mt: 4, mb: 2 }}
            />
            <Typography variant="h6">Change Password</Typography>
            <Formik
              enableReinitialize={true}
              initialValues={{
                password: '',
                newPassword: '',
                newPassword2: '',
                error: ''
              }}
              validationSchema={validateChangePasswordForm}
              onSubmit={(values) => {
                submitChangePassword(values);
              }}>
              {(propsForm) => (
                <Box sx={styles.contentContainerStyle}>
                  <Box sx={styles.boxItemStyle}>
                    <TextField
                      margin="normal"
                      variant="standard"
                      required
                      fullWidth
                      label="Current Password"
                      name="password"
                      type={showPassword1 ? 'text' : 'password'}
                      autoFocus
                      InputProps={{
                        // <-- This is where the toggle button is added.
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword1}
                              onMouseDown={handleMouseDownPassword1}>
                              {showPassword1 ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                      value={propsForm.values.password}
                      onChange={propsForm.handleChange}
                      error={propsForm.touched.password && Boolean(propsForm.errors.password)}
                      helperText={propsForm.touched.password && propsForm.errors.password}
                    />
                    <TextField
                      margin="normal"
                      variant="standard"
                      required
                      fullWidth
                      name="newPassword"
                      label="New Password"
                      type={showPassword2 ? 'text' : 'password'}
                      autoComplete="false"
                      InputProps={{
                        // <-- This is where the toggle button is added.
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword2}
                              onMouseDown={handleMouseDownPassword2}>
                              {showPassword2 ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                      value={propsForm.values.newPassword}
                      onChange={propsForm.handleChange}
                      error={propsForm.touched.newPassword && Boolean(propsForm.errors.newPassword)}
                      helperText={propsForm.touched.newPassword && propsForm.errors.newPassword}
                    />
                    <TextField
                      margin="normal"
                      variant="standard"
                      required
                      fullWidth
                      label="Repeat New Password"
                      type={showPassword3 ? 'text' : 'password'}
                      id="newPassword2"
                      autoComplete="off"
                      InputProps={{
                        // <-- This is where the toggle button is added.
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword3}
                              onMouseDown={handleMouseDownPassword3}>
                              {showPassword3 ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                      onChange={propsForm.handleChange}
                      error={
                        propsForm.touched.newPassword2 && Boolean(propsForm.errors.newPassword2)
                      }
                      helperText={propsForm.touched.newPassword2 && propsForm.errors.newPassword2}
                    />
                    <Box>
                      <Typography style={styles.errorText}>{st.updatepwderror}</Typography>
                    </Box>
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      color="primary"
                      onClick={propsForm.handleSubmit}
                      sx={{ mt: 4, mb: 1 }}>
                      Change Password
                    </Button>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mt: 4,
                        mb: 6
                      }}>
                      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                        <RouterLink
                          to="/sop2web/profile"
                          onClick={() => {
                            if (st.updatepwderror !== '') dispatch(loginActions.clearError());
                            console.info('Navigate to profile page.');
                          }}
                          sx={{ color: '#003087' }}
                          variant="body1"
                          color="inherit">
                          Back to Account Details
                        </RouterLink>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              )}
            </Formik>
          </Box>
        </Grid>
        <Footer />
      </Grid>
    </ThemeProvider>
  );
}
const styles = {
  containerStyle: {
    height: '93vh',
    backgroundColor: '#EDF3FC'
  },
  contentStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    // minWidth: 600,
    border: 0,
    my: 8
  },
  formCardContainerStyle: {
    display: 'flex',
    border: 0,
    boxShadow: 1,
    borderColor: '#747678',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: 600,
    background: '#FFFF'
  },
  boxItemStyle: {
    border: 0,
    width: 450
  },
  errorText: {
    color: '#d32f2f',
    // fontWeight: "normal",
    fontSize: 16,
    //marginBottom: 10,
    marginTop: 0,
    marginLeft: 10,
    textAlign: 'left'
  }
};
